var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 17.9487C2.22386 17.9487 2 17.7191 2 17.4359V10.7692L2 8.20513L2 5.97876C2.31278 6.09215 2.64936 6.15385 3 6.15385H17.6667C17.8508 6.15385 18 6.30691 18 6.49573V17.9487H2.5ZM0 3.07692C0 1.37759 1.34314 0 3 0H11.396C12.0057 0 12.5 0.50694 12.5 1.13227V4.10256L17.6667 4.10257C18.9553 4.10257 20 5.17402 20 6.49573V17.9487C20 19.0816 19.1046 20 18 20H2.5C1.11929 20 0 18.852 0 17.4359V10.7692V8.20513V3.07692ZM10.5 2.05128V4.10256L3 4.10257C2.44772 4.10257 2 3.64337 2 3.07692C2 2.51048 2.44772 2.05128 3 2.05128L10.5 2.05128ZM4 9.74359C4 9.17714 4.44771 8.71795 5 8.71795H12C12.5523 8.71795 13 9.17714 13 9.74359C13 10.31 12.5523 10.7692 12 10.7692H5C4.44771 10.7692 4 10.31 4 9.74359ZM5 12.8205C4.44771 12.8205 4 13.2797 4 13.8462C4 14.4126 4.44771 14.8718 5 14.8718H15C15.5523 14.8718 16 14.4126 16 13.8462C16 13.2797 15.5523 12.8205 15 12.8205H5Z",
    fill: "#B1ADA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobsIcon.6118b20af827a24a763744262e8b3b44.svg";
export { ForwardRef as ReactComponent };